type Message = {
  title: string;
  description: string | React.ReactNode;
};

type NoDataMessageProps = {
  /** The message object to display */
  message?: Message;
  className?: string;
};

export const NoDataMessage = ({
  message,
  className = ""
}: NoDataMessageProps) => {
  if (!message) return null;

  return (
    <div
      className={`flex flex-col items-center justify-center gap-1 py-5 ${className}`}
    >
      <p
        className="text-txtBody text-xl font-semibold"
        aria-label="no-data-title"
      >
        {message.title}
      </p>
      <p className="text-txtBody text-xs" aria-label="no-data-description">
        {message.description}
      </p>
    </div>
  );
};
